const accountType = {
  EXPRESS: "express",
  STANDARD: "standard",
};

const stripePaymentMethod = {
  CARD: "card",
  PAYNOW: "paynow",
};

export { accountType, stripePaymentMethod };
